export default class StringUtil {

    isBlank = self => !self || self.length === 0 || !self.trim();
    isNotBlank = self => !this.isBlank(self);
}